import React from 'react';

export default function PageHero({ eyebrow, title, lead, accent = 'bone' }) {
  const bg = accent === 'ink' ? 'bg-ink text-bone' : 'bg-bone text-ink';
  const eyebrowColor = accent === 'ink' ? '!text-brand-sage' : '';
  const lineColor = accent === 'ink' ? 'bg-brand-sage' : 'bg-brand-deep';
  const leadColor = accent === 'ink' ? 'text-bone/75' : 'text-slate2';

  return (
    <section className={`${bg}`}>
      <div className="container-page pt-14 lg:pt-20 pb-8 lg:pb-12 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          <div className={`eyebrow ${eyebrowColor}`}>
            <span className={`inline-block h-px w-8 ${lineColor} mr-2 align-middle`} />
            {eyebrow}
          </div>
          <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tighter2">
            {title}
          </h1>
        </div>
        {lead && (
          <div className="lg:col-span-5">
            <p className={`text-lg leading-relaxed ${leadColor}`}>{lead}</p>
          </div>
        )}
      </div>
    </section>
  );
}
